import { render, staticRenderFns } from "./StageOptions.vue?vue&type=template&id=58ae7731&"
import script from "./StageOptions.vue?vue&type=script&lang=js&"
export * from "./StageOptions.vue?vue&type=script&lang=js&"
import style0 from "./StageOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports